<template>
  <footer id="bjzc-footer">
    <div class="uk-container">
      <div class="bjzc-footer-content uk-flex-middle" uk-grid>
        <router-link class="uk-width-1-4@m uk-visible@m uk-width-1-5@l uk-logo" to="/">
          <img src="~@/assets/images/logo-footer.png" alt="" />
        </router-link>
        <div class="uk-width-1-5@l uk-visible@l text-wrap width-divider">
          <h4>{{ $t('footer.quick') }}</h4>
          <div>
            <router-link to="/service/criminal_case">{{ $t('service.criminal_case') }}</router-link>
            <router-link to="/service/contract_dispute">{{ $t('service.contract_dispute') }}</router-link>
          </div>
          <div>
            <router-link to="/service/family_affairs">{{ $t('service.family_affairs') }}</router-link>
            <router-link to="/service/debt_dispute">{{ $t('service.debt_dispute') }}</router-link>
          </div>
          <div>
            <router-link to="/service/intellectual_property">{{ $t('service.intellectual_property') }}</router-link>
            <router-link to="/service/enterprise_legal">{{ $t('service.enterprise_legal') }}</router-link>
          </div>
          <div>
            <router-link to="/service/non_litigation">{{ $t('service.non_litigation') }}</router-link>
            <router-link to="/service/other">{{ $t('service.other') }}</router-link>
          </div>
        </div>
        <div class="uk-width-2-3@s uk-width-1-2@m uk-width-2-5@l text-wrap width-divider">
          <h4>{{ $t('footer.contact') }}</h4>
          <div class="uk-flex">
            <span uk-icon="icon: receiver;"></span>
            <span><a href="tel:010-67665196">010-67665196</a></span>
          </div>
          <div class="uk-flex">
            <span uk-icon="icon: phone;"></span>
            <span><a href="tel:13910962198">13910962198</a></span>
          </div>
          <div class="uk-flex">
            <span uk-icon="icon: mail;"></span>
            <span><a href="mailto:13910962198@139.com">13910962198@139.com</a></span>
          </div>
          <div class="uk-flex">
            <span uk-icon="icon: location;" class="uk-flex-none"></span>
            <span>{{ $t('footer.address') }}</span>
          </div>
        </div>
        <div class="uk-width-1-3@s uk-width-1-4@m uk-width-1-5@l uk-text-center">
          <div class="bjzc-QRcode">
            <img src="~@/assets/images/QRcode.png" alt="" />
          </div>
          <span>{{ $t('footer.code') }}</span>
        </div>
      </div>
      <div class="bjzc-footer-copyright uk-text-center uk-visible@s">
        <span class="uk-width-auto@m uk-width-1-1" style="display: inline-block">{{ $t('footer.copyright') }}</span>
        <a href="https://beian.miit.gov.cn" target="__blank">京ICP备2021040752号</a>
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102005853" target="__blank">
          <img src="~@/assets/images/beian.png" alt="" />
          京公网安备11010102005853号
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>

<style lang="scss">
#bjzc-footer {
  background-color: #3d414b;
  color: #fff;

  .bjzc-footer-content {
    padding: 1.88rem 1.25rem 2.5rem;
    .uk-logo {
      padding-right: 20px;
      img {
        max-width: 162px;
      }
    }
    .text-wrap {
      padding-top: 0.63rem;
      padding-bottom: 0.63rem;
      align-self: flex-start;
      h4 {
        margin-bottom: 1.25rem;
        color: #fff;
      }
      & > div {
        font-size: 0.88rem;
        color: #fff;
        font-weight: 300;
        line-height: 1.25rem;
        & + div {
          margin-top: 10px;
        }
        .uk-icon {
          margin-right: 0.5rem;
        }
      }
      a {
        color: #fff;
        & + a {
          margin-left: 1.25rem;
        }
      }
    }
    .width-divider {
      position: relative;
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: #dcdfe6;
      }
    }
    .uk-grid-margin {
      margin-top: 1.25rem;
    }

    & > :nth-child(2) a {
      max-width: 88px;
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
      text-overflow: ellipsis;
    }
  }

  .bjzc-QRcode {
    width: 6.25rem;
    margin: 0 auto 0.63rem;
    img {
      object-fit: cover;
      width: 100%;
    }
  }

  .bjzc-footer-copyright {
    margin-bottom: 10px;
    font-size: 0.88rem;
    font-weight: 400;
    a {
      color: #fff;
      margin-left: 8px;
      img {
        margin-bottom: 4px;
      }
    }
  }
}

@media (max-width: ($screen-width-m - 1)) {
  #bjzc-footer .bjzc-footer-content :nth-child(3)::before {
    display: none;
  }
  #bjzc-footer .bjzc-footer-content {
    padding: 2.5rem 0 1.88rem;
  }
}
@media (min-width: $screen-width-l) {
  #bjzc-footer .bjzc-footer-content :nth-child(3)::before {
    display: none;
  }
}
</style>
